import React from 'react';

const FindCourse = () => {
    return (
      <div className="">
        <h1>Find Your Courses</h1>
        <button type="button" className="btn btn-outline-light text-black">
          All Courses
        </button>
        <button type="button" className="btn btn-outline-light text-black">
          All Levels
        </button>
        <button type="button" className="btn btn-outline-light text-black">
          All Categories
        </button>
        <button type="button" className="btn btn-outline-light text-black">
          All Duration
        </button>
      </div>
    );
};

export default FindCourse;